import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import OtpVerification from "./OtpVerifaction";
import PhoneNumberPage from "./PhoneNumberPage";
import { toast } from "react-toastify";
import { v4 as uuidv4 } from "uuid";
import { useLocation, useNavigate } from "react-router-dom";
import { useApiRequest } from "./Hooks/useApiRequest";
import { API_BASE_URL } from "../../config";
import NoInternet from "../../NoInterNet/component";

const LoginContainer = () => {
  const dispatch = useDispatch();
  const { makeApiRequest } = useApiRequest();
  const generatedUUID = uuidv4();
  const navigate = useNavigate();
  const location = useLocation();

  // Capture the redirect origin so we can send the user back after login
  const from = location.state?.from || null;
console.log("from",from)
  // Redux state
  const users = useSelector((state) => state.api.data?.users || []);
  const authResponse = useSelector((state) => state.api.data?.authenticateUser);
  // Fix 3: removed unused authError selector

  // Local state
  const [mobileNo, setMobileNo] = useState("");
  const [authLoading, setAuthLoading] = useState(false);
  const [isButtonDisabled, setIsButtonDisabled] = useState(true);
  const [isOTPScreen, setIsOTPScreen] = useState(false);
  const [requestId, setRequestId] = useState(null);
  const [noInternet, setNoInternet] = useState(false);
  // Fix 2: removed loader state — it was declared but never read or passed anywhere
  const [loader, setLoader]                         = useState(true);
  // URL params
  const params = new URLSearchParams(location.search);
  const tagOrderId = params.get("value"); // Fix 4: removed duplicate `uuid` variable
  const machineId = params.get("machineId");
  const route = params.get("route");
  // Fix 5: removed unused `value` variable

  // Fix 1: removed handleNetworkError — was defined but never called;
  // each handler correctly does its own inline check below

  useEffect(() => {
    setIsButtonDisabled(!/^\d{10}$/.test(mobileNo));
  }, [mobileNo]);

  useEffect(() => {
    const jwt = localStorage.getItem("UserJWTAuth");
    const Guest_clientId = localStorage.getItem("Guest_clientId");
const route = from?.split("?")[0];
console.log("route",route=="/tagOrderId")
const value = new URLSearchParams(from?.split("?")[1])?.get("value");

console.log("value-------", value); // 435345345
    if (jwt) {
      if (route == "/tagOrderId") {
  navigate(`/login?route=tagOrderId?value=${value}`, {
    state: { from: location.pathname + location.search },
  });
}
else {
      if (!Guest_clientId) navigate("/");
    }
  }
  }, []);

  useEffect(() => {
    if (authResponse) {
      setIsOTPScreen(true);
      setAuthLoading(false);
    }
  }, [authResponse]);

  const handleNetworkError = (error) => {
    if (error.code === "ERR_NETWORK" || !error.response) {
      setNoInternet(true);
      setLoader(false);
      return true;
    }
    return false;
  };

  // ─── Online / offline listeners ───────────────────────────────────────────

  useEffect(() => {
    if (!navigator.onLine) {
      setNoInternet(true);
      setLoader(false);
    }

    const goOffline = () => setNoInternet(true);
    const goOnline = () => {
      setNoInternet(false);
      setLoader(true);
    };

    window.addEventListener("offline", goOffline);
    window.addEventListener("online", goOnline);
    return () => {
      window.removeEventListener("offline", goOffline);
      window.removeEventListener("online", goOnline);
    };
  }, []);

  // ─── Mobile authentication ────────────────────────────────────────────────

  const handleAuthenticate = () => {
    localStorage.setItem("uuid", generatedUUID);
    if (isButtonDisabled) return;
    setAuthLoading(true);

    makeApiRequest({
      url: `${API_BASE_URL}/auth/user/authenticate`,
      method: "POST",
      data: { request: { mobileNo } },
      headers: {
        accept: "application/json, text/plain, */*",
        "content-type": "application/json",
        "x-device-id": localStorage.getItem("uuid") || "",
      },
      onSuccessKey: "authenticateUser",
      onErrorKey: "authenticateUser",
      handleSuccess: (res) => {
        const reqId = res?.data?.response?.requestId;
        if (reqId) setRequestId(reqId);
        setIsOTPScreen(true);
        setAuthLoading(false);
      },
      handleError: (err) => {
        setAuthLoading(false);
        if (err.code === "ERR_NETWORK") {
          setNoInternet(true);
          return;
        }
      },
    });
  };

  // ─── OTP verification ─────────────────────────────────────────────────────

  const handleSubmitOtp = (otp) => {
    makeApiRequest({
      url: `${API_BASE_URL}/auth/user/login`,
      method: "POST",
      data: { request: { mobileNo, requestId, otp } },
      headers: {
        "x-app-platform": "web",
        "x-app-version": "v1.0.1",
        "x-device-id": localStorage.getItem("uuid") || "",
        "guest-cart-id": localStorage.getItem("card_id") || "",
      },
      onSuccessKey: "otp",
      onErrorKey: "otp",
      handleSuccess: (res) => {
        if (res?.data?.status === "FAILURE") {
          toast.error(res.data.statusMessage);
          return;
        }

        if (res.data.successful) {
          localStorage.removeItem("Guest_clientId");
          toast.success("OTP verified successfully!", { autoClose: 1500 });
          localStorage.setItem("UserJWTAuth", res?.data?.response?.jwt);
          localStorage.setItem("referCode", res?.data?.response?.referCode);
          localStorage.setItem("UserId", res?.data?.response?.userId);
          localStorage.setItem("defaultPgId", 2);
          localStorage.setItem("defaultPgName", "R_UPI");
          localStorage.removeItem("google_jwt");

          // Single navigate — resolve destination first, then return
          if (route) {
            localStorage.removeItem("Guest_clientId");
            localStorage.removeItem("Guest_OauthToken");
            if (machineId) {
              navigate(`/${route}?machineId=${machineId}`);
              return;
            }
            navigate(`/${route}`);
            return;
          }

          // Return to the page the user came from, or home
          navigate(from || "/");
        }
      },
      handleError: (err) => {
        if (err.code === "ERR_NETWORK") {
          setNoInternet(true);
          return;
        }
        toast.error(err?.message || "OTP verification failed");
      },
    });
  };

  // ─── Guest / skip login ───────────────────────────────────────────────────

  const handleSkipLogin = () => {
    localStorage.setItem("uuid", generatedUUID);
    localStorage.setItem("defaultPgName", "R_UPI");
    localStorage.setItem("defaultPgId", 2);

    makeApiRequest({
      url: `${API_BASE_URL}/auth/user/guest/login`,
      method: "POST",
      data: { request: { clientId: null } },
      headers: {
        Authorization: `Bearer ${localStorage.getItem("UserJWTAuth")}`,
        "x-app-platform": "web",
        "x-app-version": "v1.0.1",
        "x-device-id": localStorage.getItem("uuid") || "",
      },
      handleSuccess: (res) => {
        if (res.data.successful) {
          toast.success("Guest login successful!");
          localStorage.setItem("uuid", generatedUUID);
          localStorage.setItem("Guest_clientId", res.data.response.clientId);
          localStorage.setItem("Guest_OauthToken", res.data.response.oauthToken);
          localStorage.setItem("UserJWTAuth", res.data.response.jwt);
          localStorage.setItem("defaultPgId", 2);
          localStorage.setItem("defaultPgName", "R_UPI");

          // Use outer-scope `route` and `machineId`, single navigate
          if (route) {
            localStorage.removeItem("Guest_clientId");
            localStorage.removeItem("Guest_OauthToken");
            if (machineId) {
              navigate(`/${route}?machineId=${machineId}`);
              return;
            }
            navigate(`/${route}`);
            return;
          }

          navigate(from || "/");
        } else {
          toast.error(res.statusMessage || "Guest login failed");
        }
      },
      handleError: (err) => {
        if (err.code === "ERR_NETWORK") {
          setNoInternet(true);
          return;
        }
        toast.error(err?.message || "Something went wrong");
      },
    });
  };

  // ─── Google login ─────────────────────────────────────────────────────────

  const onGoogleSuccess = (response) => {
    if (response.error) {
      toast.error("Google login failed");
      return;
    }

    localStorage.setItem("uuid", localStorage.getItem("uuid") || crypto.randomUUID());
    localStorage.setItem("gmail", response.profileObj.email);
    
    makeApiRequest({
      url: `${API_BASE_URL}/auth/user/google/login`,
      method: "POST",
      data: {
        googleIdToken: response.tokenId,
      },
      headers: {
        "x-app-platform": "web",
        "x-app-version": "v1.0.1",
        "x-device-id": localStorage.getItem("uuid") || "",
        "guest-cart-id": localStorage.getItem("card_id") || "",
      },
      handleSuccess: (res) => {
        if (res.data.successful) {
          localStorage.removeItem("Guest_clientId");
          localStorage.setItem("UserJWTAuth", res.data.response.jwt);
          localStorage.setItem("google_jwt", res.data.response.jwt);
        
          localStorage.setItem("defaultPgId", 2);
          localStorage.setItem("defaultPgName", "R_UPI");
          localStorage.removeItem("Guest_OauthToken");
          navigate("/");
        }
      },
      handleError: (err) => {
        if (err.code === "ERR_NETWORK") {
          setNoInternet(true);
          return;
        }
        toast.error(err?.message || "Something went wrong");
      },
    });
  };

  // ─── Render ───────────────────────────────────────────────────────────────

  if (noInternet) return <NoInternet />;

  if (isOTPScreen) {
    return (
      <OtpVerification
        setIsOTPScreen={setIsOTPScreen}
        resendCode={handleAuthenticate}
        handleSubmitOtp={handleSubmitOtp}
        tagOrderId={tagOrderId}
      />
    );
  }

  return (
    <PhoneNumberPage
      handleAuthenticate={handleAuthenticate}
      setMobileNo={setMobileNo}
      isButtonDisabled={isButtonDisabled}
      mobileNo={mobileNo}
      onGoogleSuccess={onGoogleSuccess}
      handleSkipLogin={handleSkipLogin}
      tagOrderId={tagOrderId}
    />
  );
};

export default LoginContainer;